module.exports = __webpack_public_path__ + "media/components/country-flag/static/et-f08eec771bdf19deb66f82afcbcbb092.svg";